
  import {Vue} from "vue-property-decorator";
  import Component from "vue-class-component";
  import { Alert } from "../../addons/Alert";
  //import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import router from "../../router";
  import FormInsumo from "./Form.vue"
  
  @Component({
    name: "InsumosIndex",
    components: {FormInsumo}
  })
  export default class InsumosIndex extends Vue {
    
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public dialog = false;
    datos2 = [];
    fecha = DateTime.now().toFormat('yyyy-MM-dd');
		swForm = false;
		insumo_selected = {}
    get insumos(): any {
      return this.consultorioStore.insumos;
    }
    
    public txtSearch = "";
    swEditar = false
    mounted(){
      this.getInsumos();
    }
    getInsumos(){
      this.loading
      this.consultorioService.getInsumos(this.txtSearch)
        
    }
    nuevoInsumo(){
			this.swForm = true;
			this.swEditar = false;

    }
    editar(insumo:any){
			this.swForm = true;
			this.swEditar = true;
			this.insumo_selected = insumo
      
    }
   
    close(){
        this.swForm = false;
    }
    
    get pagination(): any {
      return this.consultorioStore.pagination;
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    
  }
  